/**
 * Navigation model, shared by the desktop sidebar and the phone bottom bar so the two
 * cannot drift apart (WIREFRAMES §1.1, §1.2).
 */

export type ScreenId =
  | 'dashboard'
  | 'add'
  | 'transactions'
  | 'reports'
  | 'accounts'
  | 'cards'
  | 'loans'
  | 'receivables'
  | 'due'
  | 'tasks'
  | 'import'
  | 'settings'
  | 'branding'
  | 'categories'
  | 'reclassify'
  | 'trash'
  | 'audit'
  | 'backup';

export interface NavEntry {
  id: ScreenId;
  label: string;
  glyph: string;
  /** Present on the phone bottom bar, which carries four items and a More menu. */
  primaryOnPhone?: boolean;
  /** Renders a separator above this entry in the sidebar. */
  separatorBefore?: boolean;
}

export const NAV: NavEntry[] = [
  { id: 'dashboard', label: 'Dashboard', glyph: '⌂', primaryOnPhone: true },
  { id: 'transactions', label: 'Transactions', glyph: '≡', primaryOnPhone: true },
  { id: 'add', label: 'Add', glyph: '＋', primaryOnPhone: true },
  { id: 'reports', label: 'Reports', glyph: '▤' },
  { id: 'accounts', label: 'Accounts', glyph: '▣' },
  { id: 'cards', label: 'Cards', glyph: '▭' },
  { id: 'categories', label: 'Categories', glyph: '⊞' },
  { id: 'reclassify', label: 'Reclassify', glyph: '⇄' },
  { id: 'loans', label: 'Loans', glyph: '◈' },
  { id: 'receivables', label: 'Owed to me', glyph: '◇' },
  { id: 'due', label: 'Due now', glyph: '◉' },
  { id: 'tasks', label: 'Tasks', glyph: '☑' },
  { id: 'import', label: 'Import', glyph: '⇪', separatorBefore: true },
  { id: 'backup', label: 'Backup', glyph: '⇩' },
  { id: 'trash', label: 'Trash', glyph: '🗑' },
  { id: 'audit', label: 'Audit log', glyph: '◷' },
  { id: 'settings', label: 'Settings', glyph: '⚙' },
  { id: 'branding', label: 'Branding', glyph: '◐' },
];

export const PHONE_PRIMARY = NAV.filter((entry) => entry.primaryOnPhone);
export const PHONE_MORE = NAV.filter((entry) => !entry.primaryOnPhone);

/**
 * WD-08: phone opens on Transactions with entry ready; desktop opens on the Dashboard.
 *
 * The two form factors do different jobs — roughly six entries a day on the phone makes
 * entry the dominant action, while desktop sessions are for reporting and review.
 */
export function landingScreen(isPhone: boolean): ScreenId {
  return isPhone ? 'transactions' : 'dashboard';
}
